import type { useApiFetch } from '@/features/auth'
import type { ServiceType } from '@/features/cases'
import type { Recommendation, RecommendationStatus } from '@/features/recommendations/types'

type AuthedFetch = ReturnType<typeof useApiFetch>

export function fetchInvestorRecommendations(
  authedFetch: AuthedFetch,
  investorId: string,
): Promise<Recommendation[]> {
  return authedFetch<Recommendation[]>(`/api/v1/investors/${investorId}/recommendations`)
}

export function fetchMyRecommendations(authedFetch: AuthedFetch): Promise<Recommendation[]> {
  return authedFetch<Recommendation[]>('/api/v1/investors/me/recommendations')
}

/** Mirrors `CreateRecommendationDto`. */
export interface CreateRecommendationInput {
  serviceType: ServiceType
  reason: string
}

export function createRecommendation(
  authedFetch: AuthedFetch,
  investorId: string,
  input: CreateRecommendationInput,
): Promise<Recommendation> {
  return authedFetch<Recommendation>(`/api/v1/investors/${investorId}/recommendations`, {
    method: 'POST',
    body: JSON.stringify(input),
  })
}

export function updateRecommendationStatus(
  authedFetch: AuthedFetch,
  id: string,
  status: RecommendationStatus,
): Promise<Recommendation> {
  return authedFetch<Recommendation>(`/api/v1/recommendations/${id}`, {
    method: 'PATCH',
    body: JSON.stringify({ status }),
  })
}
